import { Analytics } from "analytics/analytics"
import { apiClient } from "api/trpc/trpc-client"
import { authCache } from "cache/authCache"
import { snackbarError } from "reusable/mui/snackbar/snackbar"
import { UserOnboardingDefaults } from "variables/variables"

export type AuthUtilsCreateAdvisorUserResponse = 'DONE' | 'AutoSignInException' | 'ERROR'

export default class AuthUtils {
   static createAdvisorUser = async (params: { firstName: string, lastName: string, email: string, jobTitle?: string }): Promise<AuthUtilsCreateAdvisorUserResponse> => {
      try {
         const { user: advisorUser } = await apiClient.user.createAdvisorUser.mutate({
            firstName: params.firstName,
            lastName: params.lastName,
            email: params.email,
            invitationEmail: authCache.inviteeEmail.get(),
            onboarding: UserOnboardingDefaults,
         })

         Analytics.setUserId(advisorUser.id)

         Analytics.setUserProperties({
            $first_name: params.firstName,
            $last_name: params.lastName,
            $email: params.email,
            "Job title": params.jobTitle,
            ...advisorUser.trialData ? {
               "Situation": advisorUser.trialData.situation,
               "Barriers": advisorUser.trialData.barriers,
            } : {}
         })

         return 'DONE'
      } catch (error: unknown) {
         if (error instanceof Error) {
            switch (error.name) {
               case 'AutoSignInException':
                  snackbarError(`Your verification code has expired. Please enter your email and password to receive a new code.`)
                  return 'AutoSignInException'
               default:
                  snackbarError(error.message || 'Unexpected error')
            }
         } else {
            snackbarError(String(error))
         }
         return 'ERROR'
      }
   }
}
